import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

const LastThreeCargoesTable = ({ cargoes }) => {
  const theme = useTheme();

  if (!cargoes || cargoes.length === 0) return null;

  const getCargoNameAtIndex = (tank, index) =>
    tank?.cargoes?.[index]?.cargoName || "\u2014";

  const headerStyle = {
    fontWeight: "900",
    textTransform: "uppercase",
    fontSize: "0.65rem",
    letterSpacing: 1.2,
    color: "text.secondary",
    borderBottom: "2px solid",
    borderColor: "divider",
    py: 2,
    bgcolor: "transparent",
  };

  const cellStyle = {
    fontSize: "0.85rem",
    fontWeight: "600",
    borderBottom: "1px solid",
    borderColor: alpha(theme.palette.divider, 0.4),
    py: 1.5,
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ width: "100%", minWidth: 600 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headerStyle, width: "15%" }}>
              Tank No.
            </TableCell>
            <TableCell sx={headerStyle}>1st Last Cargo</TableCell>
            <TableCell sx={headerStyle}>2nd Last Cargo</TableCell>
            <TableCell sx={headerStyle}>3rd Last Cargo</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {cargoes.map((tank, index) => (
            <TableRow
              key={tank.tankId || tank.tankName}
              sx={{
                bgcolor:
                  index % 2 === 0
                    ? "transparent"
                    : alpha(theme.palette.action.hover, 0.3),
                "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.02) },
              }}
            >
              <TableCell
                sx={{ ...cellStyle, fontWeight: "900", color: "primary.main" }}
              >
                {tank.tankName}
              </TableCell>
              <TableCell sx={cellStyle}>
                <Typography variant="body2" fontWeight="700">
                  {getCargoNameAtIndex(tank, 0)}
                </Typography>
              </TableCell>
              <TableCell sx={cellStyle}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="500"
                >
                  {getCargoNameAtIndex(tank, 1)}
                </Typography>
              </TableCell>
              <TableCell sx={cellStyle}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="500"
                >
                  {getCargoNameAtIndex(tank, 2)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: 2,
          bgcolor: alpha(theme.palette.info.main, 0.05),
          border: "1px solid",
          borderColor: alpha(theme.palette.info.main, 0.1),
        }}
      >
        <Typography variant="caption" color="info.main" fontWeight="800">
          NOTE:
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
          The sequence is ordered from most recent (1st) to oldest (3rd).
        </Typography>
      </Box>
    </Box>
  );
};

export default LastThreeCargoesTable;
